import React, { useContext } from 'react';

import { withStyles } from '@material-ui/styles';
import { TableCell, TableRow } from '@material-ui/core';

import { AppStorage } from '../../../../Core/Service/storage-service';
import { BranchFranchiseCompareContext } from './branchServicesProvider';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px',
        fontWeight: 700,
        border: '1px solid #ccc',
        textTransform: 'uppercase'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        // border: 'none'
        border: '1px solid rgba(0, 0, 0, 0.03)'
        // border: '1px solid rgba(0, 0, 0, 0.12)'
        // border: '1px solid #ccc'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const DashboardDataRow = ({ data, kpiValue, k, getOverallAccountCodeData, showToast, isNull, branchId, frenchise }) => {
    const portalSettings = AppStorage.getPortalSetting();

    const { Collapse, ThousandSeparatorWithoutZero } = useContext(BranchFranchiseCompareContext);

    let MADashboardActualAlign = portalSettings.portalSettingMADashboardActualAlign;
    let MADashboardBudgetAlign = portalSettings.portalSettingMADashboardBudgetAlign;
    let MADashboardVarianceAlign = portalSettings.portalSettingMADashboardVarianceAlign;
    let MADashboardKPIsAlign = portalSettings.portalSettingMADashboardKPIsAlign;
    let MADashboardActualPYAlign = portalSettings.portalSettingMADashboardActualPYAlign;
    let MADashboardVarPYAlign = portalSettings.portalSettingMADashboardVarPYAlign;
    let MADashboardNegativeBgColor = portalSettings.portalSettingMADashboardNegativeBgColor;
    let MADashboardNegativeTxtColor = portalSettings.portalSettingMADashboardNegativeTxtColor;

    const handleClick = () => {
        if (data.mappingCategoryID) {
            getOverallAccountCodeData(
                data.mappingCategoryID,
                branchId == '-99' ? '' : branchId,
                frenchise ? frenchise : '',
                data.maMappingCategoryName,
                k.categoryName
            );
        } else {
            showToast('No Record Found');
        }
    };

    const getStyle = (value) => ({
        color: value >= 0 ? 'black' : MADashboardNegativeTxtColor,
        background: value >= 0 ? '' : MADashboardNegativeBgColor
    });

    if (!Collapse[k.categoryId]) {
        if (isNull) {
            return (
                <StyledTableRow key={data.id}>
                    <StyledTableCell
                        align="left"
                        onClick={handleClick}
                        style={{
                            cursor: data.mappingCategoryID ? 'pointer' : '',
                            fontWeight: data.mappingCategoryID ? 500 : ''
                        }}
                    >
                        {data.maMappingCategoryName}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardActualAlign} style={getStyle(data.actual)}>
                        {ThousandSeparatorWithoutZero(0, k.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardBudgetAlign} style={getStyle(data.budget)}>
                        {ThousandSeparatorWithoutZero(0, k.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardVarianceAlign} style={getStyle(data.variance)}>
                        {ThousandSeparatorWithoutZero(0 || 0, k.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardKPIsAlign}>{ThousandSeparatorWithoutZero(0, k.dp)}%</StyledTableCell>

                    <StyledTableCell align={MADashboardActualPYAlign} style={getStyle(data.actualLY)}>
                        {ThousandSeparatorWithoutZero(0, k.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardVarPYAlign} style={getStyle(data.varLY)}>
                        {ThousandSeparatorWithoutZero(0, k.dp)}
                    </StyledTableCell>
                </StyledTableRow>
            );
        } else {
            return (
                <StyledTableRow key={data.id}>
                    <StyledTableCell
                        align="left"
                        onClick={handleClick}
                        style={{
                            cursor: data.mappingCategoryID ? 'pointer' : '',
                            fontWeight: data.mappingCategoryID ? 500 : ''
                        }}
                    >
                        {data.maMappingCategoryName}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardActualAlign} style={getStyle(data.actual)}>
                        {/* {formatters.ThousandSeparatorWithoutZero(data.actual)} */}
                        {ThousandSeparatorWithoutZero(data.actual, k?.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardBudgetAlign} style={getStyle(data.budget)}>
                        {/* {formatters.ThousandSeparatorWithoutZero(data.budget)} */}
                        {ThousandSeparatorWithoutZero(data.budget, k?.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardVarianceAlign} style={getStyle(data.variance)}>
                        {/* {formatters.ThousandSeparatorWithoutZero(data.variance || 0)} */}
                        {ThousandSeparatorWithoutZero(data.variance || 0, k?.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardKPIsAlign}>{ThousandSeparatorWithoutZero(kpiValue, k.dp)}%</StyledTableCell>

                    <StyledTableCell align={MADashboardActualPYAlign} style={getStyle(data.actualLY)}>
                        {/* {formatters.ThousandSeparatorWithoutZero(data.actualLY)} */}
                        {ThousandSeparatorWithoutZero(data.actualLY, k?.dp)}
                    </StyledTableCell>

                    <StyledTableCell align={MADashboardVarPYAlign} style={getStyle(data.varLY)}>
                        {/* {formatters.ThousandSeparatorWithoutZero(data.varLY)} */}
                        {ThousandSeparatorWithoutZero(data.varLY, k?.dp)}
                    </StyledTableCell>
                </StyledTableRow>
            );
        }
    } else {
        return null;
    }
};

export default DashboardDataRow;
